export type IColors = {
    white: string;
    persianGreen: string;
    azureRadiance: string;
    eggBlue: string;
    darkGreen: string;
    lightGray: string;
    lightCharcoal: string;
    lightGrayContainer: string;
    hitGray: string;
    royalBlue: string;
    codGray: string;
    charcoalGray: string;
    alto: string;
    black: string;
    silver: string;
    red: string;
    vistaWhite: string;
    orange: string;
    errorRed: string;
    purple: string;
    pink: string;
    lightGrayishBlue: string;
    darkMintGreen: string;
    darkMintBlue: string;
    darkMintRed: string;
    darkMintYellow: string;
    brightGreen: string;
    brightRed: string;
    darkBlue: string;
    white07: string;
    white40: string;
    white50: string;
    white10: string;
    white30: string;
    white70: string;
    white80: string;
    white90: string;
    darkGunmetal: string;
    lightningYellow: string;
    pirateGold: string;
    lightningYellowRgba: string;
    lightningYellowRgba2: string;
    lightningYellowRgba6: string;
    pirateGoldRgba: string;
    lightDimYellowRgba: string;
    darkGray: string;
    blackRock: string;
    charcoalBlack: string;
    progressBarFill: string;
    progressBarTrack: string;
    tuna: string;
    freshGreen: string;
    bluishCayan: string;
    orangyRed: string;
    lightGreen: string;
    lightBluishCayan: string;
    lightOrangyRed: string;
    darkBluebg: string;
    yellowText: string;
    lightOrangeYellow: string;
    yellow60: string;
    yellowButton: string;
    goldenColor: string;
    pirateGoldRgba6: string;
    green: string;
    formBlue: string;
    scrollBarColor: string;
    chineseGold: string;
    switchOffColor: string;
    switchOnColor: string;
    switchOnText: string;
    greenSwitchButton: string;
    alloyOrange: string;
    mintGreen: string;
    strongYellow: string;
    softOrange: string;
    moderateRed: string;
    strongRed: string;
    raisinBlack: string;
    midnightBlack: string;
    midGray: string;
    fadedYellow: string;
    fadedYellow80: string;
    yellow80: string;
    grayBlue: string;
    goldenGlowGradient: string;
    lightBlue: string;
    yellow: string;
    grey: string;
    greyTransparent: string;
    yellowTransparent: string;
    yellowTransparent1: string;
    blackLight: string;
    blackLight2: string;
    greyYellow: string;
    darkBlueGrey: string;
    lightBlack: string;
    lightBlack2: string;
    lightBlack3: string;
    yellowTransparent2: string;
    grey2: string;
    greyIcon: string;
    grey3: string;
    darkGreenBlack: string;
    darkGreyBlack: string;
    lightRed: string;
    greenBlue: string;
    turquoise: string;
    lightPink: string;
    oliveGreen: string;
    bananaYellow: string;
};

export const color: IColors = {
    white: '#FFFFFF',
    persianGreen: '#00B894',
    azureRadiance: '#0984E3',
    eggBlue: '#00CEC9',
    darkGreen: '#009C99',
    lightGray: '#CED4DA',
    lightCharcoal: '#00000025',
    lightGrayContainer: '#1E202A',
    hitGray: '#ADB5BD',
    royalBlue: '#3E59D7',
    codGray: '#1E1E1E',
    charcoalGray: '#00000018',
    alto: '#D0D0D0',
    black: '#000000',
    silver: '#C5C5C5',
    red: '#D63031',
    vistaWhite: '#FDFAFA',
    orange: '#FF9F43',
    errorRed: '#EA1F1F',
    purple: '#6C5CE7',
    pink: '#FFDDDC',
    lightGrayishBlue: '#6c757d',
    darkMintGreen: '#93FF781A',
    darkMintBlue: '#9ACFED1A',
    darkMintRed: '#FFA7A01A',
    darkMintYellow: '#FFDCA81A',
    brightGreen: '#57BF3E',
    brightRed: '#FF5C50',
    darkBlue: '#1E202A',
    formBlue: '#1976d2',
    white07: 'rgba(255, 255, 255, 0.07)',
    white10: 'rgba(255, 255, 255, 0.1)',
    white40: 'rgba(255, 255, 255, 0.4)',
    white50: 'rgba(255, 255, 255, 0.5)',
    white30: 'rgba(255, 255, 255, 0.3)',
    white70: 'rgba(255, 255, 255, 0.7)',
    white80: 'rgba(255, 255, 255, 0.8)',
    white90: 'rgba(255, 255, 255, 0.9)',
    darkGunmetal: '#1E202A',
    lightningYellow: '#FABB18',
    pirateGold: '#C48E02',
    lightningYellowRgba: 'rgba(250, 187, 24, 0.8)',
    lightningYellowRgba2: 'rgba(250, 187, 24, 0.2)',
    lightningYellowRgba6: 'rgba(250, 187, 24, 0.6)',
    pirateGoldRgba: 'rgba(196, 142, 2, 0.8)',
    lightDimYellowRgba: 'rgba(250, 187, 24, 0.4)',
    darkGray: '#2E313E',
    blackRock: '#292B36',
    charcoalBlack: '#1A1A20',
    progressBarFill: '#CA940A',
    progressBarTrack: '#F5DA92',
    tuna: '#363842',
    freshGreen: '#5DCF41',
    bluishCayan: '#5AC7F9',
    orangyRed: '#FF675B',
    lightGreen: 'rgba(147, 255, 120, 0.1)',
    lightBluishCayan: 'rgba(154, 207, 237, 0.1)',
    lightOrangyRed: 'rgba(255, 167, 160, 0.1)',
    darkBluebg: '#111218',
    yellowText: 'linear-gradient(105.23deg, #FABB18 0%, #C48E02 100%)',
    pirateGoldRgba6: 'rgba(196, 142, 2, 0.6)',
    lightOrangeYellow: 'rgba(255, 220, 168, 0.1)',
    yellow60: 'rgba(250, 187, 24, 0.6)',
    yellowTransparent2: 'rgba(250, 187, 24, 0.8)',
    yellowButton: '#E6BB42',
    green: 'rgba(93, 207, 65, 0.9)',
    goldenColor: '#b38611',
    scrollBarColor: '#393B45',
    chineseGold: '#C38E02',
    switchOffColor: '#6C5555',
    switchOnColor: '#3D6040',
    switchOnText: '#0E8E22',
    greenSwitchButton: '#ADFFA01A',
    alloyOrange: '#C38E0299',
    mintGreen: '#93FF784D',
    strongYellow: '#C7BF10',
    softOrange: '#DF8D51',
    moderateRed: '#C0584A',
    strongRed: '#C7431A',
    raisinBlack: '#1E1F25',
    midnightBlack: '#0000003D',
    midGray: '#7d7d82',
    fadedYellow: 'rgba(245, 179, 9, 0.04);',
    fadedYellow80: 'rgba(245, 179, 9, 0.08);',
    yellow: '#F5B309',
    yellow80: '#F5B309CC',
    greyYellow: '#F5B30914',
    grayBlue: '#26262B',
    goldenGlowGradient:
        'linear-gradient(105.23deg, rgba(250, 187, 24, 0.8) 0%, rgba(196, 142, 2, 0.8) 100%)',
    lightBlue: '#B9D9EB',
    darkBlueGrey: '#3A3A47',
    lightBlack: '#4b4f4c',
    lightBlack2: '#1a1a21',
    lightBlack3: 'rgba(255, 255, 255, 0.4)',
    grey: '#FFFFFF66',
    greyTransparent: 'rgba(39, 42, 55, 0.5)',
    yellowTransparent: 'rgba(255, 193, 7, 0.1)',
    yellowTransparent1: 'rgba(255, 193, 7, 0.2)',
    blackLight: '#151721',
    blackLight2: '#1B1D27',
    greyIcon: '#272A37',
    grey2: '#2A2D3A',
    grey3: 'rgba(255, 255, 255, 0.7)',
    darkGreenBlack: '#1E2A22',
    darkGreyBlack: '#292626',
    lightRed: '#EB5252',
    greenBlue: '#60B09C',
    turquoise: '#5AC7F9',
    lightPink: '#F3B086',
    oliveGreen: '#ABA87C',
    bananaYellow: '#F2C95D'
};
